import React, { useEffect } from "react";
import { useNavContext } from "../../context-api/nav-context";
import QuestFive from "../../components/quote-components/quoteQuestions/QuestFive";

const QuestionFive = () => {
  const { closeNavbarMenu } = useNavContext();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <main onMouseOver={closeNavbarMenu}>
      <QuestFive />
    </main>
  );
};

export default QuestionFive;
